import { useEffect } from "react";
import { AppRoutes } from "./_components/AppRoutes";
import CssBaseline from "@mui/material/CssBaseline";
import { getAuth } from "firebase/auth";
import { store } from "../redux/store";
import { setUser, flushUser } from "../redux/reducers/user";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

function App() {
  useEffect(() => {
    const unsubscribeAuth = handleUser();

    return () => unsubscribeAuth();
  }, []);

  const handleUser = () => {
    // When an auth user changes
    return getAuth().onAuthStateChanged((user) => {
      if (user) {
        const docRef = doc(db, "users", user.uid);

        // Subscribe to real-time updates
        const unsubscribeSnapshot = onSnapshot(docRef, (doc) => {
          if (doc.exists()) {
            store.dispatch(setUser(doc.data()));
          } else {
            console.warn("No such document!");
          }
        });

        return unsubscribeSnapshot;
      } else {
        console.log("No user is signed in");
        store.dispatch(flushUser());
      }
    });
  };

  return (
    <>
      <CssBaseline />
      <AppRoutes />
    </>
  );
}

export default App;
